import "./Image.css"
import {PersonRounded, Message} from "@material-ui/icons"
import dash from '../../images/dash3.png'

const Image = () => {
    return (
        <div className="back">
            <div className="back_left">
                <h2>Welcome, <span className="name">Nour</span> </h2>
                <p>To your dashboard ...</p>
            </div>
            <div className="back_right">
                <img src={dash} />
            </div>
        </div>
    )
}

export default Image;